module.exports = __webpack_public_path__ + "img/Icon_Carga_Certificaciones_Masa_Hover.df34dc11.svg";